export const esTranslation = {
  LoginPage: {
    title: 'Inicia sesión para continuar',
    'label-username': 'Usuario',
    'placeholder-username': 'Ingresa tu usuario',
    'label-password': 'Contraseña',
    'placeholder-password': 'Ingresa tu contraseña',
    'hero-title': 'Accede y continúa tu trabajo',
    'hero-subtitle': 'Tu taller, siempre a mano.',
    'banner-session-evicted':
      'Tu sesión en este dispositivo se cerró porque superaste el límite de dispositivos. Vuelve a iniciar sesión.',
    'banner-refresh-invalid': 'No pudimos renovar tu sesión. Por favor, ingresa nuevamente.',
    'banner-session-expired': 'Tu sesión expiró. Por favor, ingresa nuevamente.',
    'cta-no-account': '¿No tienes cuenta?',
    'cta-create-account': 'Crear cuenta',
  },
  SignUpPage: {
    title: 'Crea tu cuenta y comienza tu prueba gratis de 14 días',
    'label-email': 'Correo',
    'placeholder-email': 'Ingresa tu correo',
    'label-password': 'Contraseña',
    'placeholder-password': 'Ingresa tu contraseña',
    'label-confirm-password': 'Confirmar contraseña',
    'placeholder-confirm-password': 'Repite tu contraseña',
    'label-accept-terms': 'Acepto los',
    'link-terms': 'Términos y Condiciones',
    'btn-creating': 'Creando…',
    'have-account': '¿Ya tienes cuenta?',
    'link-login': 'Inicia sesión',
    'hero-title': 'La forma más inteligente de gestionar tu taller',
    'hero-subtitle': 'Un flujo claro que empodera a tu equipo.',
  },
  PasswordStrength: {
    label: 'Fuerza',
    veryWeak: 'Muy débil',
    weak: 'Débil',
    medium: 'Media',
    strong: 'Fuerte',
    minChars: '• Mínimo 8 caracteres',
    includeLettersNumbers: '• Incluye letras y números',
    matchesConfirm: '• Coincide con confirmación',
  },
  Footer: {
    copy: '© {{year}} Reparoly — Desarrollado por Iktan Consulting',
    'link-terms': 'Términos',
    'link-privacy': 'Privacidad',
    'link-contact': 'Contacto',
  },
  NavbarMenu: {
    title: 'Menú',
    placeholderName: 'Usuario',
    placeholderEmail: 'Sin correo',
    dashboard: 'Dashboard',
    payments: 'Pagos',
    warrantyPlans: 'Planes de garantía',
    settings: 'Configuración',
    settingsGroup: 'Configuración',
    'settings-company': 'Empresa',
    'settings-users': 'Usuarios',
    'settings-order-statuses': 'Estatus de orden',
    'settings-payment-methods': 'Métodos de pago',
    'settings-pos-ticket-footer': 'Políticas ticket POS',
    'settings-legal-terms': 'Términos legales',
    signOut: 'Cerrar sesión',
    language: 'Idioma',
    'language-es': 'Español',
    'language-en': 'Inglés',
  },
  SiteHeader: {
    fastSale: 'Venta rápida',
  },
  FastPOS: {
    fastSale: 'Venta rápida',
    subtitle: 'Busca productos, agrégalos al carrito y finaliza el cobro sin salir del resumen.',
    branch: 'Sucursal Centro',
    modeInfo: 'Modo venta rápida · {{date}}',
    search: {
      label: 'Buscar producto',
      placeholder: 'Buscar por nombre o SKU',
      minChars: 'Min. 4 letras',
      minCharsHint: 'Escribe al menos 4 caracteres',
      searching: 'Buscando...',
    },
    customer: {
      label: 'Cliente',
      walkIn: 'Mostrador',
    },
    terminal: {
      label: 'Terminal',
      loading: 'Cargando terminal…',
      error: 'No se pudo cargar la terminal',
      display: 'Terminal #{{id}}',
    },
    errors: {
      ensureTerminalSession: 'No se pudo preparar la terminal POS.',
      inventoryInvalid: 'Hay productos con inventario inválido.',
      inventoryInvalidDetails: 'IDs inválidos: {{ids}}',
      insufficientStock: 'No hay stock suficiente para este producto.',
      insufficientStockDetails: 'Disponibles: {{available}} · En carrito: {{inCart}}',
    },
    order: {
      title: 'Detalle de la orden',
      subtitle: 'Nombre del producto, adicionales, cantidad e importes.',
      empty: 'Agrega productos para iniciar el cobro.',
      decreaseQty: 'Disminuir cantidad',
      increaseQty: 'Aumentar cantidad',
      removeLine: 'Eliminar producto',
    },
    payment: {
      cash: 'Pagar en efectivo',
      cashDesc: 'Completa el pago usando efectivo, de forma fácil y rápida.',
      card: 'Pagar con tarjeta',
      cardDesc: 'Procesar con terminal',
      selectTitle: 'Seleccionar método de pago',
      selectDescription:
        'Selecciona el método de pago para ofrecer una experiencia de cobro fluida al cliente.',
      transfer: 'Pagar con transferencia o QR',
      transferDesc: 'Pide al cliente que el pago realizando una transferencia.',
    },
    products: {
      title: 'Resultados de productos',
      helper: 'Ejemplo visual con datos de muestra',
      sku: 'SKU',
      category: 'Categoría',
      serial: 'Serializado',
      batch: 'Lote',
      expiry: 'Caducidad',
      noResults: 'Sin resultados',
      typeToSearch: 'Escribe para ver resultados',
      available: 'Disponible: {{count}}',
      unavailable: 'Sin stock',
      add: 'Agregar',
    },
    totals: {
      subtotal: 'Subtotal',
      serviceFees: 'Cargos por servicio',
      taxes: 'Impuestos',
      discount: 'Descuento',
      total: 'Total',
      toCharge: 'Total a cobrar',
    },
    actions: {
      cancel: 'Cancelar venta',
      confirmPayment: 'Confirmar pago',
      close: 'Cerrar',
    },
    closeCash: {
      title: 'Cerrar sesión de caja',
      subtitle: 'Revisa el resumen y confirma el monto contado.',
      summaryTitle: 'Resumen de pagos',
      summary: {
        cash: 'Efectivo',
        transfer: 'Transferencia',
        refunds: 'Reembolsos',
      },
      expected: 'Efectivo esperado',
      counted: 'Total contado (cajón)',
      initialAmount: 'Monto inicial',
      difference: 'Diferencia',
      differenceShortage: 'Faltante',
      differenceOverage: 'Sobrante',
      notes: 'Notas',
      notesPlaceholder: 'Ej. Cierre con diferencia por cambio mal entregado',
      sessionLabel: 'Sesión #{{id}}',
      terminalLabel: 'Terminal',
      submit: 'Aceptar',
      cancel: 'Cancelar',
      loadingSummary: 'Cargando resumen…',
      summaryError: 'No se pudo obtener el resumen de pagos.',
      previewError: 'No se pudo previsualizar el cierre de caja.',
    },
    dailyClosure: {
      header: {
        title: 'Corte diario por fecha operativa',
        subtitle: 'Genera el cierre diario. Basado en sesiones incluidas y totales por método.',
        legendTitle: 'Fecha operativa y auditoría',
        legendDescription:
          'La operación diaria conserva la sesión en su `business_date`. La apertura real y el cierre real se muestran aparte para conciliación y soporte.',
        summaryTitle: 'Resumen del día operativo',
        branchLabel: 'Sucursal',
        businessDateLabel: 'Fecha operativa',
        existingTitle: 'Corte ya generado',
        existingDescription: 'Se reutiliza el corte #{{id}} para la fecha operativa {{date}}.',
        missingIdTitle: 'Corte existente sin identificador',
        missingIdDescription:
          'El backend confirmó un corte existente, pero no devolvió `id`. Revisa la respuesta antes de imprimir.',
      },
      filters: {
        datePlaceholder: 'Fecha operativa',
        businessDatePlaceholder: 'Fecha operativa',
        openedDatePlaceholder: 'Fecha de apertura real',
        closedDatePlaceholder: 'Fecha de cierre real',
        apply: 'Consultar',
        refresh: 'Refrescar',
        pendingChanges: 'Cambios sin aplicar',
      },
      actions: {
        create: 'Hacer corte',
        print: 'Imprimir corte',
        confirm: 'Confirmar',
      },
      dialog: {
        confirmTitle: 'Confirmar corte diario',
        confirmDescription:
          'Se generará el corte para la fecha operativa {{date}} con las sesiones listadas.',
        creatingTitle: 'Generando corte...',
        creatingDescription:
          'Se está enviando la solicitud de corte diario. Espera la confirmación.',
      },
      summary: {
        methodsTitle: 'Totales por método',
        methodsEmpty: 'No hay totales para mostrar.',
        defaultCashMethod: 'Efectivo',
        defaultCardMethod: 'Tarjeta',
        unknownMethod: 'Método',
        cashTitle: 'Dinero en caja',
        cashInitial: 'Dinero inicial en caja',
        cashSales: 'Ventas en efectivo (+)',
        cashDifference: 'Diferencia',
        cashOut: 'Salidas de efectivo (-)',
        cashExpectedTotal: 'Total esperado efectivo',
        overviewTitle: 'Resumen',
        paymentMethodsTotal: 'Total por métodos de pago',
        total: 'Total',
        notAvailable: 'No aplica en este estado.',
      },
      operation: {
        tableTitle: 'Sesiones operativas incluidas',
        tableDescription:
          'Esta vista usa `business_date` como criterio principal. Una sesión overnight permanece en la fecha operativa original, aunque su cierre real caiga al día siguiente.',
        empty: 'No hay sesiones operativas para la fecha consultada.',
      },
      audit: {
        title: 'Auditoría de sesiones',
        description:
          'Se consulta por apertura real o cierre real usando timezone IANA explícita, sin cambiar la fecha operativa del corte.',
        openedMode: 'Apertura real',
        closedMode: 'Cierre real',
        openedHelper: 'Se usa `opened_date` para rastrear la apertura real de la sesión.',
        closedHelper:
          'Se usa `closed_date` para rastrear el cierre real de la sesión, incluso si la fecha operativa fue el día anterior.',
        tableTitle: 'Sesiones auditadas',
        tableOpenedDescription:
          'Resultado filtrado por apertura real. La columna de fecha operativa permanece visible para conciliación.',
        tableClosedDescription:
          'Resultado filtrado por cierre real. La columna de fecha operativa permanece visible para conciliación.',
        emptyOpened: 'No hay sesiones con apertura real en la fecha consultada.',
        emptyClosed: 'No hay sesiones con cierre real en la fecha consultada.',
      },
      sessionsTable: {
        id: 'ID',
        terminal: 'Terminal',
        statusLabel: 'Estado',
        businessDate: 'Fecha operativa',
        openedAt: 'Apertura real',
        closedAt: 'Cierre real',
        expected: 'Esperado',
        closing: 'Cierre',
        diff: 'Diferencia',
        openedBy: 'Abierta por',
        closedBy: 'Cerrada por',
        actions: 'Acciones',
        closeAction: 'Cerrar',
        closingAction: 'Cerrando...',
        empty: 'No hay sesiones para mostrar.',
        pending: 'No hay sesiones para mostrar en este estado.',
        status: {
          open: 'Abierta',
          closing: 'En cierre',
          closed: 'Cerrada',
          cancelled: 'Cancelada',
        },
      },
      toasts: {
        createdTitle: 'Corte generado',
        createdDescription: 'Fecha operativa: {{date}}{{suffix}}',
        existingTitle: 'Corte ya existente',
        existingDescription: 'Se reutiliza el corte #{{id}} para la fecha operativa {{date}}.',
        ticketTitle: 'Ticket generado',
        ticketDescription: 'Corte #{{id}}',
      },
      notices: {
        missingExistingId:
          'El backend reportó un corte existente, pero no devolvió su identificador.',
        printRequiresExisting: 'Primero debes generar el corte para poder imprimirlo.',
        missingClosureId:
          'No se pudo resolver el identificador del corte diario. Actualiza e intenta de nuevo.',
        ticketMissingPdf: 'El ticket de corte no contiene datos de PDF.',
        ticketFailed: 'No se pudo generar el ticket de corte.',
      },
      ticket: {
        title: 'Ticket de corte',
      },
    },
    toast: {
      added: 'Producto agregado',
    },
    footerNote:
      'Al confirmar el pago se generará un ticket de venta rápida y se actualizará el inventario.',
  },
  InventoryStockPage: {
    header: {
      title: 'Inventario',
      subtitle: 'Listado de productos',
      cta: 'Nuevo Producto',
    },
    filters: {
      none: 'Sin filtros',
      count_one: '{{count}} filtro activo',
      count_other: '{{count}} filtros activos',
      rangeUnset: 'Sin rango definido',
      search: 'Buscar por SKU o nombre…',
      activityOff: 'Actividad desactivada',
      refresh: 'Refrescar',
      clear: 'Limpiar',
      apply: 'Aplicar',
      byActivity: 'Filtrar por actividad',
      supplier: 'Proveedor',
      supplierAll: 'Todos los proveedores',
      stock: 'Stock',
      sort: 'Ordenar',
    },
    stockLevels: {
      all: 'Todo',
      low: 'Stock bajo',
      out: 'Sin stock',
      high: 'Sobre inventario',
    },
    sort: {
      nameAsc: 'Nombre (A-Z)',
      nameDesc: 'Nombre (Z-A)',
      skuAsc: 'SKU ascendente',
      skuDesc: 'SKU descendente',
      availableAsc: 'Disponible ascendente',
      availableDesc: 'Disponible descendente',
    },
    summary: {
      totalSkus: 'SKUs totales',
      serialized: 'Serializados',
      nonSerialized: 'No serializados',
    },
    table: {
      headers: {
        sku: 'SKU',
        product: 'Producto',
        category: 'Categoría',
        available: 'Disponible',
        unitCost: 'Costo unitario',
        sellCost: 'Precio de venta',
        actions: 'Acciones',
      },
      actions: {
        audit: 'Ajustar',
      },
      labels: {
        units: 'u.',
      },
      status: {
        high: 'Stock alto',
        low: 'Stock bajo',
        out: 'Sin stock',
      },
      placeholders: {
        noSupplier: 'Sin proveedor',
        noCategory: 'Sin categoría',
        notAvailable: '—',
      },
      empty: 'No hay resultados para los filtros seleccionados.',
    },
    pagination: {
      empty: 'Sin resultados',
      range: 'Mostrando {{start}}-{{end}} de {{total}}',
      pageSize: 'Filas por página',
      perPage: '{{count}} por página',
      rangePrefix: '{{from}}-{{to}}',
      rangeSuffix: 'de {{total}}',
    },
  },
  InventoryAlertsPage: {
    header: {
      title: 'Alertas de stock',
      subtitle: 'Productos sin stock o con stock bajo',
      description_zero: '0 productos en alerta',
      description_one: '1 producto en alerta',
      description_other: '{{count}} productos en alerta',
    },
    filters: {
      categories: 'Categorías',
      out: 'Sin stock',
      low: 'Stock bajo',
      alert: 'Todos en alerta',
      refresh: 'Refrescar',
      share: 'Compartir',
    },
    share: {
      title: 'Compartir por WhatsApp',
      description: 'Se compartirá el texto de los productos visibles en la página actual.',
      copy: 'Copiar texto',
      whatsapp: 'Abrir WhatsApp',
      close: 'Cerrar',
      toast: {
        copySuccess: 'Texto copiado',
        copyError: 'No se pudo copiar el texto',
      },
    },
    table: {
      headers: {
        sku: 'SKU',
        name: 'Nombre',
        category: 'Categoría',
        supplier: 'Proveedor',
        stock: 'Stock',
        reserved: 'Reservado',
        available: 'Disponible',
        minStock: 'Stock mínimo',
      },
      status: {
        out: 'Sin stock',
        low: 'Stock bajo',
      },
      empty: 'No hay productos en alerta para los filtros seleccionados.',
      noCategory: 'Sin categoría',
      noSupplier: 'Sin proveedor',
      notAvailable: '—',
    },
    error: {
      title: 'No se pudo cargar el listado',
      message: 'No fue posible cargar las alertas de inventario.',
      retry: 'Reintentar',
    },
  },
  InventoryPantallasPage: {
    header: {
      title: 'Productos',
      subtitle: 'Resultados para categorías Pantallas',
      searching: 'Se está resolviendo la categoría Pantallas…',
      description_zero: '0 productos encontrados',
      description_one: '1 producto encontrado',
      description_other: '{{count}} productos encontrados',
    },
    filters: {
      categories: 'Categorías',
      stockStatus: {
        label: 'Estatus stock',
        out: 'Sin stock',
        low: 'Stock bajo',
        alert: 'Todos en alerta',
      },
    },
    actions: {
      refresh: 'Refrescar',
      share: 'Compartir',
    },
    share: {
      title: 'Compartir por WhatsApp',
      description: 'Se compartirá el texto de los productos visibles en la página actual.',
      copy: 'Copiar texto',
      whatsapp: 'Abrir WhatsApp',
      close: 'Cerrar',
      toast: {
        copySuccess: 'Texto copiado',
        copyError: 'No se pudo copiar el texto',
      },
    },
    table: {
      headers: {
        sku: 'SKU',
        name: 'Nombre',
        category: 'Categoría',
        supplier: 'Proveedor',
        stock: 'Stock',
        reserved: 'Reservado',
        available: 'Disponible',
        minStock: 'Stock mínimo',
      },
      status: {
        out: 'Sin stock',
        low: 'Stock bajo',
      },
      empty: 'La categoría Pantallas no tiene productos en alerta para mostrar.',
      noCategory: 'Sin categoría',
      noSupplier: 'Sin proveedor',
      notAvailable: '—',
    },
    empty: {
      title: 'No se encontró la categoría Pantallas',
      description: 'La búsqueda no devolvió una categoría compatible para listar productos.',
      retry: 'Buscar de nuevo',
    },
    error: {
      title: 'No se pudo cargar la categoría',
      message: 'No fue posible cargar los productos de la categoría Pantallas.',
      retry: 'Reintentar',
    },
  },
  InventoryItemForm: {
    header: {
      createTitle: 'Crear producto',
      createSubtitle: 'Registra un nuevo artículo en el catálogo.',
      editTitle: 'Editar producto',
      editSubtitle: 'Actualiza la información operativa del producto.',
    },
    fields: {
      name: {
        label: 'Nombre',
        placeholder: 'Nombre del artículo',
      },
      sku: {
        label: 'Código de producto',
        placeholder: 'Código del artículo',
      },
      description: {
        label: 'Descripción',
        placeholder: 'Opcional',
      },
      uom: {
        label: 'Unidad de medida',
        placeholder: 'Selecciona UOM',
      },
      category: {
        label: 'Categoría',
        placeholder: 'Selecciona categoría',
      },
      supplier: {
        label: 'Proveedor',
        placeholder: 'Selecciona proveedor',
      },
      buyPrice: {
        label: 'Precio compra',
      },
      sellPrice: {
        label: 'Precio venta',
      },
      minStock: {
        label: 'Mínimo en stock',
      },
      trackSerial: {
        label: 'Serializado',
      },
      trackBatch: {
        label: 'Lotes',
      },
      trackExpiry: {
        label: 'Caducidad',
      },
    },
    actions: {
      create: 'Crear producto',
      saveChanges: 'Guardar cambios',
      saving: 'Guardando…',
      generateSku: 'Generar SKU a partir del nombre',
      backToList: 'Volver al inventario',
    },
    states: {
      loading: 'Cargando producto…',
      notFound: 'No fue posible cargar el producto solicitado.',
      stockConfigUnavailable:
        'No fue posible cargar la configuración de stock del producto para editarlo de forma segura.',
    },
    toast: {
      createdPrefix: 'SKU creado:',
      viewStockLink: 'Ver stock',
      updated: 'Producto actualizado',
    },
  },
  InventoryItemActions: {
    actions: {
      menu: 'Acciones',
      edit: 'Editar',
      createPo: 'Crear PO',
      registerReceipt: 'Registrar recepción',
      deactivate: 'Desactivar producto',
    },
    errors: {
      missingItemId: 'No se pudo resolver el producto a editar.',
    },
    deactivate: {
      title: 'Desactivar producto',
      blockedTitle: 'No se puede desactivar todavía',
      description:
        'El producto saldrá del catálogo activo y ya no podrá usarse en ventas, reservas, compras ni recepciones nuevas.',
      blockedDescription:
        'Antes de desactivar el producto, primero resuelve las condiciones visibles que todavía lo mantienen operativo.',
      reasonTitle: 'Razones detectadas en esta sucursal',
      backendErrorTitle: 'No se pudo completar la desactivación',
      visibleStock: 'Sucursal visible: {{stock}} en existencia, {{reserved}} reservado.',
      cancel: 'Cancelar',
      close: 'Cerrar',
      viewStock: 'Ver existencias',
      viewReservations: 'Ver reservas',
      processing: 'Desactivando…',
      toast: {
        success: 'Producto desactivado',
        error: 'No se pudo desactivar el producto',
      },
      errors: {
        stock:
          'No se puede desactivar mientras el producto tenga existencias activas en la sucursal visible.',
        reserved:
          'No se puede desactivar mientras el producto tenga reservas activas en la sucursal visible.',
      },
    },
  },
  OrdersTable: {
    filters: {
      searchPlaceholder: 'Buscar por código, cliente o equipo',
      refresh: 'Actualizar',
      newOrder: 'Crear orden',
      statusLabel: 'Estados',
    },
    header: {
      title: 'Órdenes recientes',
      loading: 'Cargando órdenes…',
      unauthorized: 'Debes iniciar sesión para ver órdenes.',
      error: 'Error al cargar órdenes.',
      empty: 'No hay órdenes para mostrar.',
    },
    table: {
      noResults: 'Sin resultados para los filtros aplicados.',
    },
    thirdPartyDialog: {
      title: '¿La entrega será a otra persona?',
      description: 'Si es así, se solicitará una foto de la persona o de su identificación.',
      cancel: 'Cancelar',
      noPrimary: 'No',
      yesThirdParty: 'Sí',
    },
    evidenceSheet: {
      title: 'Confirmar entrega',
      description: 'Captura una foto de la persona o su identificación.',
      instructionsTitle: 'Evidencia requerida',
      instructionsBody: 'Al menos una foto como comprobante.',
      cancel: 'Cancelar',
      confirm: 'Confirmar entrega',
    },
  },
  OrderStatusTracking: {
    header: {
      title: 'Seguimiento por estatus',
      subtitle: 'Consulta órdenes según el estatus actual configurado en el taller.',
      cardTitle: 'Órdenes por estatus',
      loading: 'Cargando órdenes…',
      unauthorized: 'Debes iniciar sesión para ver órdenes.',
      error: 'Error al cargar órdenes.',
      empty: 'No hay órdenes para mostrar con los filtros actuales.',
    },
    filters: {
      searchPlaceholder: 'Buscar por código, cliente o equipo',
      statusLabel: 'Estatus',
      statusAll: 'Todos los estatus',
      sortLabel: 'Ordenar',
      sortDateAsc: 'Fecha ascendente',
      sortDateDesc: 'Fecha descendente',
      refresh: 'Actualizar',
      newOrder: 'Crear orden',
    },
    table: {
      noResults: 'Sin resultados para los filtros aplicados.',
    },
  },
  IdleTimer: {
    modalTitle: 'Actividad inactiva detectada',
    modalDescription:
      'Parece que has estado inactivo por un tiempo. ¿Quieres continuar tu sesión o cerrar la sesión?',
    stayLoggedIn: 'Permanecer',
    logout: 'Cerrar sesión',
  },
  Validations: {
    LoginCustomer: {
      username: 'Ingresa un usuario válido (mínimo 2 caracteres).',
      'password-required': 'La contraseña es obligatoria.',
      'password-invalid-type': 'Ingresa una contraseña válida.',
      'password-min': 'La contraseña debe tener al menos 8 caracteres.',
      'password-mix': 'La contraseña debe incluir letras y números.',
      'password-max': 'La contraseña no puede superar los 254 caracteres.',
    },
    SignUp: {
      'email-required': 'El correo es obligatorio.',
      'email-invalid': 'Correo inválido.',
      'password-required': 'La contraseña es obligatoria.',
      'password-invalid-type': 'Ingresa una contraseña válida.',
      'password-min': 'La contraseña debe tener al menos 8 caracteres.',
      'password-mix': 'La contraseña debe incluir letras y números.',
      'password-max': 'La contraseña no puede superar los 254 caracteres.',
      'confirm-password-required': 'Confirma tu contraseña.',
      'confirm-password-match': 'La confirmación no coincide.',
      'accept-terms-required': 'Debes aceptar los términos y condiciones.',
    },
    ClientForm: {
      'name-required': 'El nombre es requerida',
      'name-invalid-type': 'El nombre debe ser un texto',
      'name-min': 'El nombre debe tener al menos 4 caracteres',
      'name-max': 'El nombre no puede exceder los 254 caracteres',
      'contact-number-required': 'El número de contacto es requerida',
      'contact-number-invalid-type': 'El número de contacto debe ser un texto',
      'contact-number-min': 'El número de contacto debe tener al menos 9 caracteres',
      'contact-number-max': 'El número de contacto no puede exceder los 15 caracteres',
      'phone-number-required': 'La número telefónico es requerida',
      'phone-number-invalid-type': 'La número telefónico debe ser un texto',
      'phone-number-min': 'La número telefónico debe tener al menos 5 caracteres',
      'phone-number-max': 'La número telefónico no puede exceder los 254 caracteres',
    },
    Equipment: {
      'branch-required': 'Selecciona una sucursal.',
      'model-required': 'Selecciona un modelo.',
      'type-required': 'Selecciona un tipo de equipo.',
      'deviceKind-required': 'Selecciona el tipo de dispositivo.',
      'deviceKind-invalid': 'Tipo de dispositivo inválido.',
      'passwordRequired-required': 'Indica si el equipo requiere contraseña o patrón.',
      'security-required':
        'Debes especificar el método de seguridad si el equipo requiere contraseña o patrón.',
      'security.method-required': 'Selecciona el método de seguridad.',
      'security.value-required':
        'Ingresa la contraseña o define el patrón según el método elegido.',
      'imei-required': 'Ingresa el IMEI o número de serie.',
      'imei-min': 'El IMEI/Serie debe tener al menos 2 caracteres.',
      'imei-max': 'El IMEI/N° de serie no puede exceder 32 caracteres.',
      'failure-required': 'Describe la falla reportada.',
      'failure-max': 'La descripción de la falla no puede exceder 1000 caracteres.',
      'diagnostic-required': 'Describe el diagnóstico realizado.',
      'diagnostic-min': 'El diagnóstico debe tener al menos 10 caracteres.',
      'diagnostic-max': 'El diagnóstico no puede exceder 2000 caracteres.',
      'observations-max': 'Las observaciones no pueden exceder 2000 caracteres.',
      'warranty-required': 'Selecciona la garantía.',
      'warranty-invalid': 'Valor de garantía inválido.',
    },
    Budget: {
      'budget-required': 'Ingresa un presupuesto.',
      'budget-min': 'El presupuesto debe ser 0 o mayor.',
      'advance-required': 'Ingresa un anticipo.',
      'advance-min': 'El anticipo debe ser 0 o mayor.',
      'advance-lte-budget': 'El anticipo no puede ser mayor al presupuesto.',
      'total-required': 'El total es requerido.',
      'total-min': 'El total debe ser 0 o mayor.',
      'total-mismatch': 'El total no coincide con el cálculo.',
      'payment-method-required': 'Selecciona un método de pago.',
      'payment-method-invalid': 'Método de pago inválido.',
    },
    CloseCashSession: {
      'closingAmount-required': 'Ingresa el monto contado en caja.',
      'closingAmount-invalid': 'Ingresa un monto válido.',
      'closingAmount-min': 'El monto no puede ser negativo.',
      'notes-required': 'Agrega una nota cuando hay diferencia en el cierre.',
      'notes-max': 'Las notas no pueden superar 255 caracteres.',
    },
    SignatureConsent: {
      'sign-contract-required': 'La firma es requerida',
      'accept-terms-consent': 'Debes aceptar los términos y condiciones.',
    },
    CompanyForm: {
      'name-required': 'El nombre del taller es obligatorio.',
      'name-min': 'Debe tener al menos 2 caracteres.',
      'name-max': 'No puede exceder 254 caracteres.',
      'legal_name-required': 'La razón social es obligatoria.',
      'legal_name-min': 'Debe tener al menos 3 caracteres.',
      'legal_name-max': 'No puede exceder 254 caracteres.',
      'tax_id-required': 'El RFC es obligatorio.',
      'tax_id-min': 'RFC inválido.',
      'tax_id-max': 'RFC inválido.',
      'email-required': 'El correo es obligatorio.',
      'email-invalid': 'Correo inválido.',
      'address1-required': 'La dirección es obligatoria.',
      'address1-min': 'Debe tener al menos 3 caracteres.',
      'address1-max': 'No puede exceder 254 caracteres.',
      'city-required': 'La ciudad/municipio es obligatoria.',
      'city-min': 'Debe tener al menos 2 caracteres.',
      'state-required': 'El estado es obligatorio.',
      'state-min': 'Debe tener al menos 2 caracteres.',
      'postal_code-required': 'El código postal es obligatorio.',
      'postal_code-min': 'Código postal inválido.',
      'postal_code-max': 'Código postal inválido.',
      'country-required': 'El país es obligatorio.',
      'country-min': 'Debe tener al menos 2 caracteres.',
      'phone-required': 'El teléfono es obligatorio.',
      'phone-min': 'Teléfono inválido.',
      'phone-max': 'Teléfono inválido.',
      'currency_code-required': 'Selecciona una moneda.',
      'currency_code-invalid': 'Moneda inválida.',
    },
  },

  DashboardPage: {
    cards: {
      revenueToday: 'Ganancias del día',
      repairsToday: 'Reparaciones del día',
      clients: 'Clientes',
      balance: 'Por cobrar',
      detail: 'Detalle',
      errorSummary: 'Error al cargar el resumen. Intenta más tarde.',
    },
    productivity: {
      title: 'Productividad por técnico',
      error: 'Error al cargar productividad.',
    },
    chart: {
      title: 'Estatus de órdenes',
      legendPending: 'Pendientes',
      legendCompleted: 'Completados',
      rangeDay: 'Día',
      rangeWeek: 'Semanal',
      rangeMonth: 'Mensual',
      rangePlaceholder: 'Últimos 3 meses',
      ariaSelectRange: 'Seleccionar periodo',
    },
  },
  HelpMenu: {
    ariaLabel: 'Abrir ayuda',
    supportTitle: 'Ayuda y soporte',
    supportDescription: 'Guías rápidas y solución de problemas.',
    contactTitle: 'Póngase en contacto',
    contactEmail: 'soporte@intakconsulting.com',
    contactPhone: '+52 999 222 1751',
    contactRegion: 'México',
    supportSubject: 'Ayuda con Reparoly',
    updatesTitle: 'Novedades',
    updates: {
      timezone: {
        title: 'Soporte de zona horaria',
        description: 'Se añadió sincronización por zona horaria en reportes.',
      },
      earnings: {
        title: 'Detalle de ganancias del día',
        description: 'Se agregó la vista para ver el origen de las ganancias.',
      },
    },
  },
  HelpTimezonePage: {
    title: 'Guía de zona horaria',
    subtitle: 'Conoce cómo actualizarla y qué afectaciones tiene el cambio.',
    steps: {
      title: 'Cómo cambiarla',
      subtitle: 'Sigue estos pasos en la configuración de empresa.',
      step1: 'Ir a Configuración → Empresa.',
      step2: 'Seleccionar la zona horaria correcta.',
      step3: 'Guardar cambios para aplicar la actualización.',
    },
    actions: {
      openSettings: 'Ir a configuración de empresa',
    },
    impact: {
      title: 'Qué cambia al actualizarla',
      subtitle: 'Afecta reportes, cortes y métricas diarias.',
      item1: 'Los reportes se sincronizan con la nueva zona horaria.',
      item2: 'El cambio aplica a partir de la actualización; no es retroactivo.',
      item3: 'Ejemplo: GMT-6 corresponde a Ciudad de México.',
      note: 'Se recomienda avisar al equipo si se modifica la zona horaria.',
    },
  },

  HomePage: {
    title: 'Seleccione una opción',
    'receive-title': 'Recepcionar equipo',
    'receive-desc':
      'Crea la orden para iniciar el proceso de reparación registrando datos necesarios.',
    'search-title': 'Buscar orden',
    'search-desc': 'Encuentra órdenes de servicio por número de orden, cliente o equipo.',
  },
  SearchPage: {
    title: 'Buscar',
    description: 'Encuentra órdenes por orden, cliente o equipo.',
    'result-title': 'Resultado',
    'help-enter-code': 'Ingresa un # orden, cliente o equipo y pulsa Buscar.',
    'label-status': 'Estatus:',
    'label-imei': 'IMEI/Serie:',
    'btn-searching': 'Buscando…',
    'error-fetch': 'Error al consultar la orden.',
    'validation-min': 'Ingresa al menos {{count}} caracteres para buscar.',
  },
  SearchScanPage: {
    'aria-close': 'Cerrar',
    'starting-camera': 'Iniciando cámara…',
    'last-label': 'Último:',
    errors: {
      'generic-camera-access': 'No se pudo acceder a la cámara.',
      'permission-denied': 'Permiso de cámara denegado. Autoriza el acceso en tu navegador.',
      'not-found': 'No se encontró cámara disponible en el dispositivo.',
      'not-readable': 'La cámara está siendo usada por otra aplicación.',
      overconstrained: 'No se pudo iniciar la cámara con los parámetros solicitados.',
      'order-not-found': 'No se encontró la orden.',
    },
  },
  SummaryPage: {
    title: 'Resumen de la orden',
    subtitle: 'Recepción en proceso',
    'total-to-pay': 'Total a pagar:',
  },
  EquipmentPhotosPage: {
    title: 'Fotos del equipo',
    subtitle: 'Captura evidencia al recibir el equipo.',
    'helper-max-files': 'Puedes subir hasta {{count}} archivos',
  },
  PhotoSlot: {
    alt: 'Foto {{number}}',
    'btn-capture': 'Capturar',
    'btn-retake': 'Volver a Capturar',
    'aria-capture': 'Capturar foto',
    'aria-retake': 'Reemplazar foto',
  },
  OrderSerialsDialog: {
    title: 'Registro de seriales',
    description: 'Completa los seriales pendientes antes de cambiar el estado a “En reparación”.',
    info: 'Captura todos los seriales para cambiar la orden a “En reparación”.',
    loadingCamera: 'Activando cámara…',
    live: {
      noPending: 'No hay piezas pendientes de serializar.',
      start: 'Captura todos los seriales para continuar a “En reparación”.',
      progress: 'Avance {{percentage}}%. Completa los seriales restantes.',
      ready: 'Todo listo. Puedes registrar y avanzar a “En reparación”.',
      submitError: 'No fue posible registrar los seriales. Verifica e inténtalo nuevamente.',
    },
    list: {
      loading: 'Cargando piezas pendientes…',
      error: 'No fue posible cargar las reservas. Intenta nuevamente.',
      empty: 'La orden no tiene piezas pendientes de serializar.',
      retry: 'Reintentar',
    },
    slot: {
      skuLabel: 'SKU: {{sku}}',
      label: 'Serial #{{index}}',
      hint: 'Capturar o  escáner serial',
      button: 'Escanear',
      placeholder: 'SN-ABCDE1234',
      badgeReady: 'Listo',
      badgePending: 'Pendiente',
      ariaInput: 'Serial {{index}} para SKU {{sku}}',
    },
    validation: {
      required: 'Requerido',
      invalid: 'El serial debe tener entre 16 y 20 caracteres (A–Z, 0–9 o -).',
      duplicate: 'Serial duplicado, verifica la captura.',
    },
    actions: {
      cancel: 'Cancelar',
      submit: 'Continuar',
      progress: '{{percentage}}% completado',
      saving: 'Registrando…',
    },
    scanner: {
      title: 'Escanear serial',
      hint: 'Apunta la cámara al código y espera unos segundos.',
      providerLabel: 'Motor de escaneo',
      zxing: 'ZXing',
      quagga: 'Quagga2 (beta)',
      footer: 'Escanea códigos de barras, QR y más',
    },
    messages: {
      scanSuccess: 'Serial capturado correctamente.',
      submitSuccessTitle: 'Seriales registrados',
      submitSuccess: 'Los seriales se guardaron correctamente.',
    },
  },
  BudgetPage: {
    title: 'Presupuesto',
    subtitle: 'Por favor, llene los siguientes campos',
    'label-budget': 'Presupuesto',
    'label-advance': 'Anticipo',
    'label-payment-method': 'Método de pago',
    'aria-budget': 'Presupuesto estimado',
    'aria-advance': 'Anticipo recibido',
    'aria-payment-method': 'Seleccionar método de pago',
    'placeholder-payment-method': 'Seleccionar método',
    payment: {
      cash: 'Efectivo',
      card: 'Tarjeta',
      transfer: 'Transferencia',
      other: 'Otro',
    },
    summary: 'Resumen',
    'summary-title': 'Resumen',
    'total-budget-label': 'Total a pagar:',
    'dialog-title': '¿Quieres registrar otro equipo?',
    'dialog-description':
      'Si presionas "Sí", continuarás con la captura de otro equipo del mismo cliente.',
    'dialog-btn-yes': 'Sí, agregar otro',
    'dialog-btn-no': 'No, continuar',
  },
  EquipmentSummary: {
    'client-title': 'Cliente',
    'label-name': 'Nombre',
    'label-phone': 'Teléfono de contacto',
    'item-title': 'Equipo {{number}}',
    'meta-imei': 'IMEI/Serie',
    'meta-failure': 'Falla reportada',
    'meta-parts': 'Piezas',
    'meta-budget': 'Costo de servicio',
    'meta-advance': 'Anticipo',
    'total-label': 'Total',
  },
  DiscardDialog: {
    title: '¿Descartar avance?',
    description:
      'Si cancelas ahora, perderás el avance de los equipos ya capturados. Esta acción no se puede deshacer.',
    'btn-discard': 'Descartar',
    'btn-continue': 'Continuar aquí',
    'redirect-back-to-client': 'y volver a Cliente',
  },
  SecurityDialog: {
    title: 'Información de acceso',
    description: 'Selecciona un método (contraseña o patrón) y completa el campo correspondiente.',
    'draw-title': 'Dibuja patrón',
    'label-method': 'Método',
    'label-method-access': 'Método de acceso',
    'placeholder-method-access': 'Selecciona contraseña o patrón',
    'placeholder-method': 'Selecciona un método',
    'option-password': 'Contraseña',
    'option-pattern': 'Patrón de desbloqueo',
    'option-none': 'Sin bloqueo / No aplica',
    'placeholder-password': 'Ingresa la contraseña',
    'validation-method-required': 'Selecciona un método',
    'validation-complete-according-method': 'Completa el campo según el método elegido',
  },
  AddCatalogDialog: {
    title: 'Agregar cliente',
    'label-name': 'Nombre',
    'placeholder-name': 'Ingresa nombre',
    'btn-save': 'Guardar',
    'btn-saving': 'Guardando...',
  },
  OptionPage: {
    title: 'Buscar reserva o contrato',
    subtitle: 'Por favor ingresa la información de tu reserva o contrato.',
    'label-username': 'Usuario',
    'placeholder-username': 'Ingresa usuario',
    'label-password': 'Contraseña',
    'placeholder-password': 'Ingresa contraseña',
  },
  ClientPage: {
    title: 'Datos del cliente',
    subtitle: '',
    'label-name': 'Nombre',
    'placeholder-name': 'Ingresa nombre',
    'label-phone-number': 'Número telefónico',
    'placeholder-phone-number': 'Ingresa número telefónico',
    'label-contact-number': 'Número de contacto',
    'placeholder-contact-number': 'Ingresa número de contacto',
  },
  CompanySettings: {
    title: 'Configuraciónes de la empresa',
    subtitle: 'Gestiona la información del taller para comunicación y branding.',
    'card-title': 'Datos generales',
    'title-steps': 'Completa los datos',
    'tab-general': 'General',
    'tab-print-template': 'Plantilla de impresión',
    'btn-upload-logo': 'Subir logo',
    'btn-remove-logo': 'Quitar',
    'btn-save': 'Guardar cambios',
    'toast-saved': 'Datos de la empresa guardados',
    'error-logo-format': 'Formato no soportado. Usa PNG o JPG.',
    'error-logo-size': 'El logo debe ser menor a 2MB.',
    'label-name': 'Nombre comercial del taller',
    'placeholder-name': 'Ej. Taller Reparoly',
    'label-legal_name': 'Razón social',
    'placeholder-legal_name': 'Ej. Reparoly S. de R.L. de C.V.',
    'label-tax_id': 'RFC',
    'placeholder-tax_id': 'Ej. ABCD010101XYZ',
    'label-email': 'Correo electrónico',
    'placeholder-email': 'contacto@taller.com',
    'label-phone': 'Teléfono',
    'placeholder-phone': 'Ej. +52 55 1234 5678',
    'label-currency': 'Moneda',
    'label-timezone': 'Zona horaria',
    'label-address1': 'Calle y número',
    'placeholder-address1': 'Ej. Calle 60 #123',
    'label-address2': 'Colonia',
    'placeholder-address2': 'Ej. Col. Centro',
    'label-city': 'Ciudad/Municipio',
    'placeholder-city': 'Ej. José María Morelos',
    'label-state': 'Estado',
    'placeholder-state': 'Ej. Quintana Roo',
    'label-postal_code': 'Código postal',
    'placeholder-postal_code': 'Ej. 77890',
    'label-country': 'País',
    'placeholder-country': 'Ej. México',
    'placeholder-timezone': 'Selecciona la zona horaria',
    'search-timezone': 'Buscar zona horaria...',
    'empty-timezone': 'Sin resultados',
    'timezone-group-detected': 'Detectado',
    'timezone-group-america': 'América',
    'timezone-group-europe': 'Europa',
    'timezone-group-asia': 'Asia',
    'timezone-group-africa': 'África',
    'timezone-group-oceania': 'Oceanía',
    'timezone-group-utc': 'UTC',
    'timezone-guide-title': 'Guía rápida de zona horaria',
    'timezone-guide-item-1': 'Se usa para sincronizar reportes y cortes diarios.',
    'timezone-guide-item-2': 'El cambio aplica a datos nuevos; no es retroactivo.',
    'timezone-guide-item-3': 'Ejemplo: GMT-6 (Ciudad de México).',
  },
  EquipmentPage: {
    title: 'Datos del equipo',
    subtitle: '',
    'add-device-title': 'Agregar dispositivo',
    'add-device-subtitle': 'Tipo o familia del equipo.',
    'add-device-field-label': 'Nombre del dispositivo',
    'add-device-field-placeholder': 'Ej.: Celular, Tablet, Consola',
    'add-device-confirm': 'Guardar dispositivo',
    'add-brand-title': 'Agregar marca',
    'add-brand-subtitle': 'Fabricante o marca comercial del dispositivo.',
    'add-brand-field-label': 'Nombre de la marca',
    'add-brand-field-placeholder': 'Ej.: Samsung, Apple, Lenovo',
    'add-brand-confirm': 'Guardar marca',
    'add-model-title': 'Agregar modelo',
    'add-model-subtitle': 'Modelo específico dentro de la marca seleccionada.',
    'add-model-subtitle-brand':
      'Modelo específico dentro de la marca seleccionada: <strong>{{brand}}</strong>.',
    'add-model-field-label': 'Nombre del modelo',
    'add-model-field-placeholder': 'Ej.: Galaxy S23, iPhone 14 Pro, ThinkPad X1',
    'add-model-confirm': 'Guardar modelo',
    'label-equip-branch': 'Marca',
    'placeholder-equip-branch': 'Selecionar marca',
    'label-equip-model': 'Modelo',
    'placeholder-equip-model': 'Selecionar modelo',
    'label-equip-type': 'Dispositivo',
    'placeholder-equip-type': 'Selecionar tipo de dispositivo',
    'label-equip-imei': 'IMEI - Serie',
    'placeholder-equip-imei': 'Ingresa IMEI - Serie',
    'label-equip-password': 'Check si el dispositivo usa contraseña',
    'placeholder-equip-password': 'Indica si el equipo tiene bloqueo/contraseña.',
    'label-equip-security-notes': 'Indicaciones de acceso',
    'placeholder-equip-security-notes': 'PIN, patrón, Face/Touch, etc.',
    'label-equip-failure': 'Falla',
    'placeholder-equip-failure': 'Describir falla',
    'label-equip-diagnostic': 'Diagnóstico',
    'placeholder-equip-diagnostic': 'Describir diagnóstico',
    'label-equip-observations': 'Observaciones',
    'placeholder-equip-observations': 'Ingresar observaciones',
    'label-equip-warranty': 'Garantía',
    'placeholder-equip-warranty': 'Seleccionar garantía',
    'option-phone': 'Celular',
    'option-tablet': 'Tablet',
    'option-other': 'Otro',
  },
  SignatureConsent: {
    title: 'Aceptación de presupuesto',
    subtitle: 'Por favor, firma para autorizar el servicio conforme a las condiciones.',
    steps: 'Paso 6 de 6',
    'label-terms-conditionals': 'Acepto los términos y condiciones del servicio.',
    'label-privacy-notice': 'Ver',
    'label-signature': 'Firma aquí',
    'btn-correct': 'Corregir',
    'btn-continue': 'Continuar',
  },
  PaymentsPage: {
    title: 'Pagos recientes',
    subtitle: 'Visualiza actividad y lista de pagos',
    tabs: {
      payments: 'Pagos',
      inventoryPos: 'Venta',
      byOrder: 'Reparaciones',
    },
    posTable: {
      loading: 'Cargando...',
      empty: 'Sin resultados.',
      expand: 'Expandir',
      collapse: 'Contraer',
      sort: {
        netDesc: 'Neto desc',
        netAsc: 'Neto asc',
        saleDesc: 'Venta desc',
        saleAsc: 'Venta asc',
      },
      headers: {
        sale: 'Venta',
        dateTime: 'Fecha/Hora',
        productMain: 'Productos',
        extras: 'Extras',
        itemsCount: 'Ítems',
        units: 'Unidades',
        cost: 'Costo',
        charge: 'Cobro',
        refund: 'Reembolso',
        net: 'Neto',
      },
      commercialFallback: '-- detalle no disponible --',
      multiProducts: '{{count}} productos',
      detail: {
        headers: {
          product: 'Producto',
          sku: 'SKU',
          qty: 'Cantidad',
          subtotal: 'Subtotal',
        },
        empty: 'Sin detalle comercial.',
      },
    },
    byOrderTable: {
      title: 'Ganancias totales',
      loading: 'Cargando...',
      empty: 'Sin resultados.',
      filters: {
        status: 'Estatus',
      },
      sort: {
        dateDesc: 'Fecha desc',
        dateAsc: 'Fecha asc',
        balanceDesc: 'Saldo desc',
        balanceAsc: 'Saldo asc',
      },
      headers: {
        order: 'Orden',
        client: 'Cliente',
        equipment: 'Equipo',
        totalCost: 'Total',
        totalPaid: 'Pagado',
        totalRefunded: 'Reembolsado',
        balance: 'Saldo',
        paymentStatus: 'Estatus',
        status: 'Estado',
        createdAt: 'Fecha',
      },
      status: {
        complete: 'Completo',
        partial: 'Parcial',
      },
    },
    filters: {
      searchPlaceholder: 'Buscar pago o método',
      methods: 'Métodos',
      source: 'Origen',
      refresh: 'Refrescar',
      sort: {
        dateDesc: 'Fecha desc',
        dateAsc: 'Fecha asc',
        amountDesc: 'Monto desc',
        amountAsc: 'Monto asc',
      },
      status: {
        label: 'Estatus',
        pending: 'Pendiente',
        completed: 'Completado',
        void: 'Anulado',
        refunded: 'Reembolsado',
        active: 'Activo',
        inactive: 'Inactivo',
      },
    },
    table: {
      headers: {
        payment: 'Pago',
        method: 'Método',
        date: 'Fecha',
        dateTime: 'Fecha/Hora',
        type: 'Tipo de pago',
        sourceType: 'Origen',
        amount: 'Monto',
      },
      sources: {
        serviceOrder: 'Servicio',
        posSale: 'Venta',
        unknown: 'Otro',
      },
      empty: 'Sin resultados.',
    },
    badges: {
      deposit: 'Pago parcial',
      liquidation: 'Pago total',
    },
  },
  SettingsPaymentMethods: {
    title: 'Métodos de pago',
    subtitle: 'Administra los métodos de pago disponibles para tu compañía.',
    filters: {
      search: 'Buscar por código o nombre',
      status: {
        label: 'Estado',
        active: 'Activo',
        inactive: 'Inactivo',
      },
    },
    table: {
      headers: {
        code: 'Código',
        name: 'Nombre',
        created: 'Creado',
        updated: 'Actualizado',
        status: 'Estado',
      },
      empty: 'Sin resultados.',
    },
    cta: {
      new: 'Nuevo método',
      newTitle: 'Nuevo método de pago',
      newDescription: 'Completa los datos para crear un método.',
      created: 'Método de pago creado',
    },
  },
  SettingsPosTicketFooter: {
    title: 'Políticas de ticket POS',
    subtitle:
      'Configura las políticas de devolución/reemplazo que se imprimen al final del ticket POS.',
    limits: 'Se imprimen de 1 a 8 líneas; cada línea debe tener entre 3 y 160 caracteres.',
    preview: {
      empty: 'Sin líneas para previsualizar.',
    },
    editor: {
      title: 'Políticas de devolución y reemplazo',
      description: 'Se captura una línea por política para mejorar lectura en ticket térmico.',
      lineSectionLabel: 'Líneas de política',
      lineItemLabel: 'Línea',
      linePlaceholder: 'Ej. Cambios solo con ticket y dentro de 30 días.',
      addLine: 'Agregar línea',
      removeLine: 'Eliminar línea',
      clearAll: 'Limpiar todo',
      clearAllConfirm: 'Se eliminarán todas las líneas capturadas. ¿Deseas continuar?',
      emptyStateTitle: 'No hay líneas configuradas',
      emptyStateDescription:
        'Agrega la primera línea para construir las políticas que se imprimirán en el ticket.',
      emptyStateActionLabel: 'Agregar primera línea',
      lineCounter: '{{count}}/{{max}} caracteres',
      validLineCount: 'Líneas válidas: {{count}}/{{max}}',
      previewToggleLabel: 'Ver cómo se imprime en ticket',
      previewTitle: 'Vista previa del ticket',
      bulkTitle: 'Pegar bloque (opcional)',
      bulkDescription: 'Si ya tienes el texto completo, pégalo y se reemplazará la lista actual.',
      bulkPlaceholder:
        'Escribe una política por línea.\nEj. No hay devoluciones en software abierto.',
      bulkApply: 'Aplicar bloque',
      bulkEmptyWarning: 'Pega al menos una línea para aplicar el bloque.',
      bulkMaxWarning: 'El bloque supera el máximo de 8 líneas.',
    },
    validation: {
      minLines: 'Debes capturar al menos una línea.',
      maxLines: 'Máximo 8 líneas.',
      lineMin: 'Cada línea debe tener al menos 3 caracteres.',
      lineMax: 'Cada línea no puede exceder 160 caracteres.',
    },
    company: {
      save: 'Guardar políticas',
      saved: 'Políticas de ticket POS actualizadas.',
    },
    permissions: {
      noRead: 'No tienes permiso para consultar las políticas de ticket POS.',
      readOnly: 'Modo solo lectura: no tienes permiso para guardar cambios en esta política.',
    },
  },
  Orders: {
    'serials-block': {
      'info-title': 'Seriales sin registrar ({{count}})',
      'with-count': 'Captura los seriales faltantes antes de cambiar el estado',
      'no-count': 'Captura los seriales pendientes antes de avanzar a "{{status}}"',
      'fallback-status': 'el estatus seleccionado',
    },
  },
  'btn-login': 'Ingresar',
  'btn-signup': 'Crear cuenta',
  'btn-accept': 'Entendido',
  'btn-cancel': 'Cancelar',
  'btn-previous-step': 'Paso anterior',
  'btn-take-picture': 'Tomar foto',
  'btn-search': 'Buscar',
  'btn-process': 'Procesar',
  'btn-continue': 'Continuar',
  'btn-skip': 'omitir',
  'btn-finished': 'Finalizar',
  'btn-retry': 'Reintentar',
  'btn-use-photo': 'Usar foto',
  'btn-delete': 'Eliminar',
  'title-dialog': 'Aviso',
  'title-selected-language': 'Lenguaje {{language}}',
  'placeholder-search': 'Buscar ...',
  'btn-add-item': 'Agregar nuevo',
  'badge-label-required': '(Obligatorio)',
  'badge-label-optional': '(Opcional)',
};

export type TranslationKeys = typeof esTranslation;
